import { LoadingWidget } from '@axa-asia/emma-loading-widget';
import React from 'react';
// import './styles.css';

interface PlayBackTimeProps {
  className: string;
}

const Spinner: React.SFC<PlayBackTimeProps> = () => (
  <LoadingWidget isLoading content="spinner" target="rhs" />
);

export default Spinner;
